import React from 'react';
import { withStyles } from '@mui/styles';
import { MenuItem } from '@mui/material';

const StyledMenuItem = withStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
}))(MenuItem);

export default StyledMenuItem;
